<template>
    <v-container fluid class="profile-page">
        <v-card>
            <v-app-bar dark color="primary">
                <v-icon class="mr-3">mdi-account</v-icon>
                <v-toolbar-title>Profile</v-toolbar-title>
            </v-app-bar>
            <v-container height="700px" fluid>
                <v-row>
                    <v-col cols="12" md="12" lg="12" class="text-center">
                        <v-row no-gutters>
                            <v-col class="pa-2 text-center" cols="12">
                                <v-skeleton-loader
                                        class="d-flex justify-center justify-lg-center"
                                        transition="scale-transition"
                                        type="avatar"
                                        :loading="avatarLoader"
                                >
                                <v-avatar v-if="image.content!==null" size="200">
                                    <v-img  :src="'data:image/jpeg;base64,'+image.content"></v-img>
                                </v-avatar>
                                    <v-avatar v-else size="200">
                                        <v-img src="../../../assets/Portrait_placeholder.png"></v-img>
                                    </v-avatar>
                                </v-skeleton-loader>
                                <v-tooltip v-model="show" right color="info">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon v-bind="attrs" v-on="on">
                                <v-file-input
                                        v-model="file"
                                        :rules="rules"
                                        class='pa-0' height='0' hide-details
                                        prepend-icon="mdi-account-edit"
                                        :clearable= false
                                        @change="uploadProfilePicture"
                                        :show-size=true accept="image/jpeg"
                                ></v-file-input>
                                        </v-btn>
                                    </template>
                                    <span>{{text}}</span>
                                </v-tooltip>
                            </v-col>
                            <v-col class="py-0 text-center">
                                <v-list-item light>
                                    <v-list-item-content>
                                        <v-list-item-title class="title align-center">{{user.name}}</v-list-item-title>
                                        <v-list-item-subtitle></v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                        </v-row>
                        <v-row class="move-right" justify="center">
                            <v-col cols="12" lg="3" md="3" class="mt-lg-10">
                                <v-simple-table>
                                    <template v-slot:default>
                                        <tbody>
                                        <tr>
                                            <td class="profile-label table-text">Username</td>
                                            <td class="table-text">:</td>
                                            <td class="table-text">{{user.username}}</td>
                                        </tr>
                                        <tr>
                                            <td class="profile-label table-text">Name</td>
                                            <td class="table-text">:</td>
                                            <td class="table-text">{{user.name}}</td>
                                        </tr>
                                        <tr>
                                            <td class="profile-label table-text">Staff ID</td>
                                            <td class="table-text">:</td>
                                            <td class="table-text">{{user.staffId}}</td>
                                        </tr>
                                        <tr v-if="isLoanOfficer">
                                            <td class="profile-label table-text">Branch</td>
                                            <td class="table-text">:</td>
                                            <td class="table-text">{{user.branch}}</td>
                                        </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                                <span class="small-text">*Click on icon below profile picture to upload new profile picture</span>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
        <v-snackbar v-model="imageError" :multi-line="multiLine" top color="info">
            {{ text }}
            <v-btn color="white" text @click="imageError = false">
                Close
            </v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>
    import {dataServices} from "../../../services";

    export default {
        name: "Profile",
        data() {
            return {
                file: [],
                rules: [
                    value => !value || value.size < 200000 || 'Avatar size should be less than 20 kb!',
                ],
                imageError : false,
                multiLine: true,
                text: 'Image size should be less than 20 kb',
                image: {
                    content: null
                },
                user : {
                    username: '',
                    Name: '',
                    staffId: '',
                    branch: ''
                },
                avatarLoader: true,
                show : false
            }
        },
        methods: {
            uploadProfilePicture: function () {
                this.avatarLoader = true
                if (this.file !== null && this.file.size < 20000){
                    console.log(this.file.size)
                    dataServices.uploadProfilePicture(this.file).then(response => {
                        console.log(response)
                        if (response !== null){
                            this.getProfilePic()
                        }else if (this.file === null) {
                            this.imageError = true
                            this.avatarLoader = false
                        }
                    })
                }else {
                    this.imageError = true
                    this.avatarLoader = false
                }
            },
            getProfilePic: function() {
                dataServices.getProfilePicture().then(response => {
                    if (response.dataResponse.image){
                        this.image = response.dataResponse.image
                    }
                    this.avatarLoader = false
                }).catch(error => {
                    console.log ('file ' + error)
                })

            },
            getUserInfo: function () {
                dataServices.getUserInfo().then(response => {
                    if (response.dataResponse.user){
                        this.user.username = response.dataResponse.user.username
                        this.user.name = response.dataResponse.user.fullname
                        this.user.staffId = response.dataResponse.user.idNumber
                        this.user.branch = response.dataResponse.user.branch
                    }
                }).catch(error => {
                    console.log('user' + error)
                })
            }
        },
        computed: {
            isLoanOfficer: function () {
                return this.$store.state.home.user.roles.includes('ROLE_LOAN_OFFICER')
            }
        },
        mounted() {
            this.getProfilePic()
            this.getUserInfo()
        }
    }
</script>

<style>
    .profile-page .v-file-input {
        margin: 0;
        justify-content: center;
    }
    .profile-page .v-input__control {
        display: none;
    }
    .profile-page .v-input__prepend-outer {
        margin: 0;
    }
</style>
